import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  tempData: null,
};

export const userReducer = createSlice({
  name: "UserReducer",
  initialState,
  reducers: {
    logInUser: (state, action) => {
      state.user = action.payload;
    },
    updateLogInUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
    logOutUser: (state) => {
      state.user = null;
    },
    storeTempData: (state, action) => {
      state.tempData = action.payload;
    },
    logOutTempUser: (state) => {
      state.tempData = null;
    },
  },
});

export const {
  logInUser,
  logOutUser,
  updateLogInUser,
  storeTempData,
  logOutTempUser,
} = userReducer.actions;
